import type { SyncExternalBranchJobStatus } from '../enums/SyncExternalBranchJobStatus'

export class ExternalBranchJobEntity {
  id?: string
  externalBranchId?: number
  externalBranchName?: string
  status?: SyncExternalBranchJobStatus
  createdAt?: string
}
